<template>
  <div class="kw_make_week">
    周课表显示
    <!-- 显示区域 开始 -->
    <el-table v-if="ifLoad" :data="tableData" height="450" border size="mini" stripe style="width: 100%" :row-style="rowStyleCount">
      <!-- 循环表头行信息信息 -->
      <el-table-column v-for="(headOne,headIndex) in tableHead" :key="headIndex" :prop="headOne.prop" :label="headOne.label" :fixed="headOne.fixed" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row['if_'+headOne.prop]" :style="scope.row[headOne.prop]&&headOne.prop!='timeInterval'?'background:red;position: absolute;top: 0;left: 0;width: 100%;z-index: 100;height:'+scope.row['height_'+headOne.prop]+'px;':''" >
            <span style="margin-left: 10px;" v-if="scope.row[headOne.prop]">
              {{scope.row[headOne.prop]}}
            </span>
          </div>
          <div v-else :style="scope.row[headOne.prop]&&headOne.prop!='timeInterval'?'background:#82fb9c;position: absolute;top: 0;left: 0;width: 100%;z-index: 100;height:'+scope.row['height_'+headOne.prop]+'px;':''" >
            <el-checkbox v-model="scope.row['check_'+headOne.prop]" :style="scope.row[headOne.prop]&&headOne.prop!='timeInterval'?'margin-left: 10px;':''" @change="(value)=>clickCheckBox(value,headOne,scope.row)"></el-checkbox>
            <span style="margin-left: 10px;" v-if="scope.row[headOne.prop]">
              {{scope.row[headOne.prop]}}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 显示区域 结束 -->
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_make_week',
  props: {
    value: {
      type: Object,
      default: function(){
        return {};
      }
    },
    dataInfo:{
      type: Object,
      default: function(){
        return {};
      }
    }
  },
  data() {
    return {
      ifLoad:false,
      // 表头行信息
      tableHead:[],
      // 数据信息
      tableData:[],
      scheduleData:[]
    };
  },
  created() {
    
  },
  mounted() {
    var that = this;
    this.initLoadDate();
  },
  watch:{
  },
  computed:{
  },
  components: {
    
  },
  methods: {
    /**
     * 进行数据初始化加载
     */
    initLoadDate:function(){
      var that = this;
      this.ifLoad = false;
      //获取需要显示的时段进行时段数组的生成
      this.$nextTick(function(){
        that.loadTableHead();
        that.loadTableData();
        that.ifLoad = true;
      })
    },
    /**
     * 加载表头行
     */
    loadTableHead:function(){
      var setData = this.setData;
      var tableHead = [];
      var xhIndex = 1;
      while(xhIndex <= 7) {
        tableHead.push({
          prop:"week_"+xhIndex,
          label:"周"+xhIndex,
          fixed:false
        })
        xhIndex++;
      }
      this.tableHead = tableHead;
    },
    /**
     * 加载表格数据
     */
    loadTableData:function(){
      var that = this;
      var setData = this.setData;
      var scheduleData = this.scheduleData;
      var tableData = [];

      // 循环所有课程的已排周时段数据 按照时段信息进行合并显示 时段信息通过 弹出层读取
      console.log("childPageJsonArr===================",that.value.childPageJsonArr);
      var courseList = that.value.childPageJsonArr;
      var timeList = null;
      var scheduleData = [];
      courseList.forEach((courseOne, xhIndex) => {
        var lastField = courseOne.fieldSet[fieldSet.fieldSet.length-1];
        scheduleData.pushAll(lastField.childPageJsonArr);
        if(timeList == null) {
          var timeField = lastField.childFieldSet[lastField.childFieldSet.length-1];
          timeList = timeField.dicList;
        }
      });
      if(courseList && courseList.length > 0) {
        var courseOne = courseList[0];
        var lastField = courseOne.fieldSet[fieldSet.fieldSet.length-1];
        var timeField = lastField.childFieldSet[lastField.childFieldSet.length-1];
        var timeList = timeField.dicList;
        timeList.forEach(element => {
          var tableDataOne = {};
          //已排课时间段进行表格显示
          scheduleData.forEach((scheduleOne, xhIndex) => {
            var scheduleCourseId = scheduleOne.SCHEDULE_COURSE_ID;
            var scheduleStudyDate = scheduleOne.STUDY_DATE;
            var scheduleStartDate = scheduleOne.START_DATE;
            var scheduleEndDate = scheduleOne.END_DATE;
            var scheduleMinutes = scheduleOne.MINUTES;
            var scheduleHeight = setData.rowHeight*(scheduleMinutes/setData.minutesInterval);
            //判断时段在当前的表格内
            var scheduleStartDateStr = pageUtils.dateFormat(new Date(scheduleStartDate), "HH:mm");
            if(scheduleStartDateStr >= startTimeStr && scheduleStartDateStr < endTimeStr) {
              tableDataOne["if_date_"+scheduleStudyDate] = false;
              tableDataOne["date_"+scheduleStudyDate] = scheduleOne["SCHEDULE_COURSE_NAME"] + " " + scheduleStudyDate + " " + (scheduleOne["SCHEDULE_TEA_NAME"]&&scheduleOne["SCHEDULE_TEA_NAME"]!='undefined'?scheduleOne["SCHEDULE_TEA_NAME"]:"") + " " + (scheduleOne["SCHEDULE_ROOM_NAME"]&&scheduleOne["SCHEDULE_ROOM_NAME"]!='undefined'?scheduleOne["SCHEDULE_ROOM_NAME"]:"");
              tableDataOne["height_date_"+scheduleStudyDate] = scheduleHeight;
              tableDataOne["check_date_"+scheduleStudyDate] = true;
            }
          });
          tableData.push(tableDataOne);
        });
      }


      // if(setData.hvType) {
      //   // 时段作为表头行

      // } else {
      //   // 日期作为表头行
      //   var xhTime = new Date("2020-01-01 " + setData.startTime);
      //   var endTime = new Date("2020-01-01 " + setData.endTime);
      //   while(pageUtils.dateFormat(xhTime, "yyyy-MM-dd HH:mm") < pageUtils.dateFormat(endTime, "yyyy-MM-dd HH:mm")) {
      //     var startTimeStr = pageUtils.dateFormat(xhTime, "HH:mm");
      //     xhTime.setMinutes(xhTime.getMinutes()+setData.minutesInterval);
      //     var endTimeStr = pageUtils.dateFormat(xhTime, "HH:mm");
      //     var tableDataOne = {
      //       "timeInterval":startTimeStr + "-" + endTimeStr
      //     };
      //     //已排课时间段进行表格显示
      //     scheduleData.forEach((scheduleOne, xhIndex) => {
      //       var scheduleCourseId = scheduleOne.SCHEDULE_COURSE_ID;
      //       var scheduleStudyDate = scheduleOne.STUDY_DATE;
      //       var scheduleStartDate = scheduleOne.START_DATE;
      //       var scheduleEndDate = scheduleOne.END_DATE;
      //       var scheduleMinutes = scheduleOne.MINUTES;
      //       var scheduleHeight = setData.rowHeight*(scheduleMinutes/setData.minutesInterval);
      //       //判断时段在当前的表格内
      //       var scheduleStartDateStr = pageUtils.dateFormat(new Date(scheduleStartDate), "HH:mm");
      //       if(scheduleStartDateStr >= startTimeStr && scheduleStartDateStr < endTimeStr) {
      //         tableDataOne["if_date_"+scheduleStudyDate] = false;
      //         tableDataOne["date_"+scheduleStudyDate] = scheduleOne["SCHEDULE_COURSE_NAME"] + " " + scheduleStudyDate + " " + (scheduleOne["SCHEDULE_TEA_NAME"]&&scheduleOne["SCHEDULE_TEA_NAME"]!='undefined'?scheduleOne["SCHEDULE_TEA_NAME"]:"") + " " + (scheduleOne["SCHEDULE_ROOM_NAME"]&&scheduleOne["SCHEDULE_ROOM_NAME"]!='undefined'?scheduleOne["SCHEDULE_ROOM_NAME"]:"");
      //         tableDataOne["height_date_"+scheduleStudyDate] = scheduleHeight;
      //         tableDataOne["check_date_"+scheduleStudyDate] = true;
      //       }
      //     });
      //     //教师的占用时间段进行表格显示
      //     that.showTeaTimeResource("TEA",tableDataOne,startTimeStr,endTimeStr);
      //     //教室的占用时间段进行表格显示
      //     that.showTeaTimeResource("ROOM",tableDataOne,startTimeStr,endTimeStr);
      //     tableData.push(tableDataOne);
      //   }
      // }
      console.log("tableData==========1111=====================================",tableData);
      this.tableData = tableData;
      // this.countCoursePlanHour();
    },
    /**
     * 计算已排课时
     */
    countCoursePlanHour:function(){
      var that = this;
      var courseList = this.courseList;
      var scheduleData = this.scheduleData;
      var childPageJsonArr = [];
      var courseMap = {};
      scheduleData.forEach((scheduleOne, xhIndex) => {
        var scheduleCourseId = scheduleOne.SCHEDULE_COURSE_ID;
        if(!courseMap["COURSE_"+scheduleCourseId]) {
          courseMap["COURSE_"+scheduleCourseId] = 0;
        }
        courseMap["COURSE_"+scheduleCourseId] = courseMap["COURSE_"+scheduleCourseId] + scheduleOne.HOUR;
      });
      courseList.forEach((courseOne, xhIndex) => {
        // courseOne.COURSE_PLAN_HOUR = courseMap["COURSE_"+courseOne[this.courseIdKey]]?courseMap["COURSE_"+courseOne[this.courseIdKey]]:0;
        that.$set(courseOne,"COURSE_PLAN_HOUR", courseMap["COURSE_"+courseOne[this.courseIdKey]]?courseMap["COURSE_"+courseOne[this.courseIdKey]]:0);
      });
      this.courseList = courseList;
      var value = this.value;
      var scheduleField = value.fieldSet[this.scheduleIndex];
      console.log("scheduleData=================",scheduleData);
      scheduleField.defaultCheckDataList = scheduleData;
      console.log("scheduleField=================",scheduleField);
      // that.$emit("changeScheduleData",value,that.filedIndex)
      pageUtils.confirmDialogCallBack(that,scheduleField, that.filedIndex);
    },
    /**
     * 点击时 进行排课或者取消操作
     */
    clickCheckBox:function(value, column, row){
      var that = this;
      var setData = this.setData;
      var scheduleData = this.scheduleData;
      var courseList = this.courseList;
      var currentRowIndex = this.currentRowIndex;
      var courseOne = courseList[currentRowIndex];
      var studyDate = "";
      var startEndTime = "";
      if(setData.hvType) {
        // 时段作为表头行
        
      } else {
        // 日期作为表头行
        studyDate = column.label;
        startEndTime = row.timeInterval;
      }
      var startTime = startEndTime.split("-")[0];
      var startTimeStr = studyDate + " " + startTime;
      var minutesLength = setData.minutesLength;
      var minutesInterval = setData.minutesInterval;
      var startDate_date = new Date(startTimeStr);
      console.log("startDate_date=======================",startDate_date, minutesLength,value);
      // 判断是 排课 还是取消排课
      if(value) {
        minutesLength = courseOne.COURSE_MINUTES_LENGTH*courseOne.COURSE_BOUT_HOUR;
        //获取需要排的课程
        startDate_date.setMinutes(startDate_date.getMinutes()+minutesLength);
        var endTimeStr = pageUtils.dateFormat(startDate_date, "yyyy-MM-dd HH:mm");
        // 排课  排课时校验课程是否已经存在 是否已经时间冲突
        var shceduleOne = {
          "SCHEDULE_COURSE_ID":courseOne[that.courseIdKey],
          "SCHEDULE_COURSE_NAME":courseOne.COURSE_NAME,
          "SCHEDULE_TEA_ID":courseOne.TEA_ID,
          "SCHEDULE_TEA_NAME":courseOne.TEA_NAME,
          "SCHEDULE_ROOM_ID":courseOne.ROOM_ID,
          "SCHEDULE_ROOM_NAME":courseOne.ROOM_NAME,
          "STUDY_DATE":studyDate,
          "START_DATE":startTimeStr,
          "END_DATE":endTimeStr,
          "MINUTES":minutesLength,
          "HOUR":courseOne.COURSE_BOUT_HOUR
        };
        var ifAddFlag = that.addScheduleDataOne(scheduleData,shceduleOne);
        console.log("ifAddFlag==================",ifAddFlag);
        console.log("row==================",row);
      } else {
        startDate_date.setMinutes(startDate_date.getMinutes()+minutesInterval);
        var endTimeStr = pageUtils.dateFormat(startDate_date, "yyyy-MM-dd HH:mm");
        // 取消排课
        for (let index = 0; index < scheduleData.length; ) {
          const scheduleOne = scheduleData[index];
          var scheduleStudyDate = scheduleOne.STUDY_DATE;
          var scheduleStartDate = scheduleOne.START_DATE;
          var scheduleEndDate = scheduleOne.END_DATE;
          var scheduleMinutes = scheduleOne.MINUTES;
          var scheduleHeight = setData.rowHeight*(scheduleMinutes/setData.minutesInterval);
          //判断时段在当前的表格内
          var scheduleStartDateStr = pageUtils.dateFormat(new Date(scheduleStartDate), "yyyy-MM-dd HH:mm");
          console.log("delete===========",scheduleStartDateStr, startTimeStr, endTimeStr);
          if(!(startTimeStr >= scheduleEndDate || endTimeStr <= scheduleStartDateStr)) {
            console.log("delete===========",index);
            // 数组中删除元素
            scheduleData.splice(index,1);
          } else {
            index++;
          } 
        }
      }
      that.scheduleData = scheduleData;
      that.loadTableData();
    },
    /**
     * 增加一条排课记录 进行排课校验
     */
    addScheduleDataOne:function(scheduleData,addOne){
      var that = this;
      var ifAddFlag = true;
      var startTimeStr = addOne.START_DATE;
      var endTimeStr = addOne.END_DATE;
      console.log("addOne===============",addOne);
      scheduleData.forEach((scheduleOne, xhIndex) => {
        var scheduleStartDate = scheduleOne.START_DATE;
        var scheduleEndDate = scheduleOne.END_DATE;
        //判断时段在当前的表格内
        if(!(startTimeStr >= scheduleEndDate || endTimeStr <= scheduleStartDate)) {
          ifAddFlag = false;
        }
      });
      var teaIfAddFlag = that.checkTeaTimeResource("TEA",startTimeStr,endTimeStr);
      var message = "";
      if(!teaIfAddFlag) {
        ifAddFlag = false;
        message = "时间冲突不可排!";
      }
      var roomIfAddFlag = that.checkTeaTimeResource("ROOM",startTimeStr,endTimeStr);
      if(!roomIfAddFlag) {
        ifAddFlag = false;
        message = "教室冲突不可排!";
      }
      console.log("teaIfAddFlag==========================",teaIfAddFlag);
      //判断 已排课时小于总课时
      var hourIfAddFlag = that.checkHourAdequate(addOne);
      if(!hourIfAddFlag) {
        ifAddFlag = false;
        message = "课时数不够不可排!";
      } 
      if(ifAddFlag) {
        scheduleData.push(addOne);
      } else {
        alert(message);
      }
      return ifAddFlag;
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
